import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { AudioMiniPlayerComponent } from '@common-standalone/audio-mini-player/audio-mini-player.component';
import { BANNER_CONSTANTS } from '@commoncore/constants/bannerConstants';
import { GlobalService } from '@commoncore/services/global.service';
import { AppEvents, EventsList } from '@commoncore/utils/app-events';
import { ENV_CONFIG } from '@env-properties/environment-config';
import { DependenciesModule } from '@modules/dependencies/dependencies.module';
@Component({
  standalone:true,
  selector: 'app-tabbed-view',
  templateUrl: './tabbed-view.component.html',
  styleUrls: ['./tabbed-view.component.scss'],
  imports:[DependenciesModule,AudioMiniPlayerComponent]
})
export class TabbedViewComponent implements OnInit {
    public universalService:any;
    tabData:any;
    tabDetails:any=[];
    @Input() scrollToTopIcon:boolean;
    @Input() viewType:any="";
    currentTab: any;
    currentView:any="";
    @Output() tabClicked = new EventEmitter();
    @Output() restore = new EventEmitter();
    @Output() deleteForever = new EventEmitter();
    static tabbedRef: any;
    public showSlider = true;
    router:any;
    localStorageSvc:any;
    tabViewClassForDevice: any = "";
    shareAccessService:any;
    http:any;
    bannerIsPresent:boolean = false;
    extraSpace: boolean;
    showDropDown:boolean = false;
    userData : any;
    isTabbedLayout : boolean = false;
    constructor(public globalService:GlobalService) {
      TabbedViewComponent.tabbedRef = this;
      this.setEnvObjects(globalService);
    }

    @HostListener('window:resize', [])resize(){
      var self = this;
      this.universalService.checkDeviceType();
      this.registerEvents();
      this.setActiveTab({"id" : this.universalService.tabClicked});
    }

    sendActiveTabEvents() {
      if(this.router.url.includes('/allfiles') || this.router.url.includes('/photos') || this.router.url.includes('/videos') || this.router.url.includes('/audio') || this.router.url.includes('/docs')) {
        this.renderTabbedViewAsPerTab('My Files');
      } else if(this.router.url.includes('/shared/')) {
        this.renderTabbedViewAsPerTab('Shared Files');
      } else if(this.router.url.includes('/albums/')) {
        this.renderTabbedViewAsPerTab('Albums');
      } else if(this.router.url.includes('/favorites/')) {
        this.renderTabbedViewAsPerTab('Favorites');
      }
    }
    

    ngOnInit(): void {
      this.fetchJSONContents();
    }
    applyTabViewClass() {
      if(this.universalService.isMobileDevice) {
        this.tabViewClassForDevice = ""
      } else {
        this.tabViewClassForDevice = "mr-3"
      }
    }
    setEnvObjects(globalService){
      this.universalService = globalService.getUniversalServiceRef();
      this.router = globalService.getRouterRef();
      this.localStorageSvc = globalService.getLocalStorageSvcRef();
      this.shareAccessService = globalService.getShareAccessServiceRef();
      this.http = globalService.getHttpClientRef();
    }
  
    audioPreviewFromAnotherTab(tab){ 
    
      this.switchTab(tab);
    }
    switchTab(tab,click=false){ 
      var self = this;
      if(!tab){
        return
      }
      if(!click && !this.universalService.hideTabs && !this.universalService.isMobileDevice && tab.id!="allfiles" && window.location.href.includes("allfiles")){
        // tab = JSON.parse('{"iconName":"NeueFolderFilled","id": "allfiles","name": "All Files","slideItemClass": "slide-item-1"}')
        return;
      }
        
      this.showDropDown = false;
      clearInterval(this.universalService.refreshIntervalTimerForThirdParty)
      if(this.universalService.activeRepo != 'share'){
        this.universalService.headingTitle.set(this.currentView);
      }
      this.currentTab = tab["name"];
      this.universalService.targetUrl = this.currentTab.toLowerCase();
      this.setActiveTab(tab);
      this.universalService.tabClicked = tab["id"];
      AppEvents.emit(EventsList.TAB_CLICKED,this.tabDetails)
  }
  setActiveTab(tab){
    if(tab != '') {
      this.universalService.showTabSlider = false;
      if(window.location.href.includes("?u") &&  !this.shareAccessService.invalidUnivShareKey  )
        this.universalService.showTabSlider = true
      this.tabDetails.map(t=>{
        jQuery('#'+t["id"]).removeClass('active')
      })
      setTimeout(() => {
        jQuery('#'+tab["id"]).addClass('active')
      }, 100);
      setTimeout(() => {
        if(this.universalService.inAppWebViewOpened){
          this.setSliderForInAppView(tab);
        }else{
          this.setSliderForNormalWebView(tab);
        }
        this.updateAnimation();
      }, 100);
    }
  }
  updateAnimation(){
    if(this.universalService.currentTab == 'allfiles' || this.universalService.currentTab=="photos" || this.universalService.currentTab=="audio" || this.universalService.currentTab=="videos" || this.universalService.currentTab=="docs"){
      if(this.universalService.selectedTab == 'My Files'){
        if(this.router.url.includes('/filter/recents')){
          this.universalService.setAnimationStatus('Recent Files')
        }else{
          this.universalService.setAnimationStatus('MyFiles')
        }
      }else if(this.universalService.selectedTab == 'Albums' || this.universalService.selectedTab == 'Album Details'){
        this.universalService.setAnimationStatus('Albums')
      }
    }
  }
  
  setSliderForNormalWebView(tab){
    var elWidth = (document.querySelector('.slidemenu')) as any;
    var slider = (document.querySelector('.slider')) as any;
    var label : any = "";
    if(tab && tab["id"] != undefined) {
      tab = tab["id"];
    }
    label = (document.querySelector("#" + tab)) as any;
    if(label!=null){
      var labelWidth = label.offsetWidth;
      var left = label.offsetLeft;
      slider.style.width = labelWidth + "px";
      slider.style.transform = "translateX("+left+"px)"
    }
  }
  
  setSliderForInAppView(tab){
    var elWidth = (document.querySelector('.slidemenu')) as any;
    var slider = (document.querySelector('.slider')) as any;
    var label = (document.querySelectorAll(".tabbed-label")) as any;
    var labelWidth = elWidth.offsetWidth/(this.tabDetails.length) + "px";
    label.forEach(tab => {
      tab.style.width = labelWidth;
    });
    // var left = label.offsetLeft;
    var left = $("#"+tab["id"]).position().left
    slider.style.width = labelWidth;
    slider.style.transform = "translateX("+left+"px)"
  }
  scrollToTop() {
    
    var container="";
    if((this.universalService.currentTab == 'allfiles' || this.universalService.currentTab == 'PrivateFolder') && !this.router.url.includes('/albums')){
      if(this.router.url.includes('recents')){
        container = ".scrollableContainer";
      }else{
        container = ".allFilesScrollableContainer";
      }
    }else if(this.universalService.currentTab == 'Profile'){
      container= ".profile-main-wrapper"
    }
    else if(this.router.url.includes('/albums')){
      container = '.scrollableContainer'
    }else if(this.router.url.includes('/orderhistory')){
      container = '.current-plan-main'
    }else if(this.universalService.selectedTab == "Home"){
      container = '.home-screen-container'
    }else if(this.universalService.currentTab == "CloudBridge"){
      container = '.main-cloud-bridge-cont'
    }else{
      container = ".scrollableContainer";
    }

    if(this.universalService.virtualGridEnabled){
      container = ".cdk-virtual-scroll-viewport"
    }
    $(container).animate({
      scrollTop: 0
    }, "fast");
    $(".ag-layout-normal").animate({
      scrollTop: 0
    }, "fast");
  }
  restoreItems(){
    this.restore.emit();
  }
  deleteConfirmation(){
    this.deleteForever.emit();
  }
  registerEvents(){
    let classRef = TabbedViewComponent.tabbedRef;
    AppEvents.on(EventsList.MYFILES_TABBED_VIEW, function(){
      classRef.universalService.selectedTab = 'My Files'
      classRef.renderTabbedViewAsPerTab('My Files');
    })
    AppEvents.on(EventsList.FAVORITES_TABBED_VIEW, function(){
      classRef.universalService.selectedTab = 'Favorites'
      classRef.renderTabbedViewAsPerTab('Favorites')
      classRef.removeUploadButtons()
    })
    AppEvents.on(EventsList.EMPTY_TABBED_VIEW, function(viewName){
      if(viewName != "search" && viewName != "recents"){
        classRef.setTabValuesForEmptyTabs();
      }
      classRef.renderTabbedViewAsPerTab('EmptyTab')
      classRef.removeUploadButtons();
      classRef.universalService.showTabSlider = false;
    })
    AppEvents.on(EventsList.SHARED_FILES_TABBED_VIEW, function(){
      classRef.universalService.selectedTab = 'Shared Files'
      classRef.renderTabbedViewAsPerTab('Shared Files')
    })
    AppEvents.on(EventsList.SHARED_PUBLIC_TABBED_VIEW, function(){
      classRef.renderTabbedViewAsPerTab('SharePublic')
    })
    AppEvents.on(EventsList.ALBUM_LIST_TABBED_VIEW, function(){
      classRef.universalService.selectedTab = 'Albums'
      classRef.renderTabbedViewAsPerTab('Albums');
    })

    AppEvents.on(EventsList.UNIVERSAL_SHARE_TABBED_VEW, function(){
      //classRef.universalService.selectedTab = 'Albums'
      setTimeout(function() {
        classRef.setSliderForNormalWebView(classRef.shareAccessService.showShareTabName);
      }, 100);
      setTimeout(() => {
        AppEvents.bannerEvent.next(BANNER_CONSTANTS.STORAGE_BANNER);
      }, 2000);
    })

    AppEvents.on(EventsList.HIGHLIGHT_ACTIVE_TAB, function(){
      //classRef.universalService.selectedTab = 'Albums'
      setTimeout(function() {
        var tab = classRef.getDetailsOfCurrentTab(classRef.universalService.currentTab);
        classRef.setActiveTab(tab);
      }, 100);
    })

    AppEvents.on(EventsList.ENT_MEMBER_TEAMS_FOLDER_TABBED_VIEW, function(){
      classRef.universalService.selectedTab = "TeamsFolderOperations"
      classRef.renderTabbedViewAsPerTab('Team_Folder_Member');
    })

    AppEvents.on(EventsList.ENT_ADMIN_TEAMS_FOLDER_TABBED_VIEW, function(){
      classRef.universalService.selectedTab = 'TeamsFolderOperations'
      classRef.renderTabbedViewAsPerTab('Team_Folder_Admin');
    })

    AppEvents.on(EventsList.ENT_VIEWER_TEAMS_FOLDER_TABBED_VIEW, function(){
      classRef.universalService.selectedTab = 'TeamsFolderOperations'
      classRef.renderTabbedViewAsPerTab('Team_Folder_Member_Viewer');
    })
  }

  removeUploadButtons(){
    if(this.universalService.isMobileDevice && this.universalService.activeRepo == 'main' && this.currentView!='My Files'){
      setTimeout(() => {
          $('#tabs.nav-tabs').css('margin-top',0)
      }, 100);
    }
  }
  async renderTabbedView(tabName,emptyTabbedView=false){ 
    var self = this;
    this.showSlider = true;
    this.extraSpace = false;
    this.universalService.hideTabs = false;  
    this.userData = this.localStorageSvc.getUserData(true);
    switch(tabName){ 
      case "My Files": 
        this.currentView = "My Files";
        this.tabDetails = emptyTabbedView ? [] : self.tabData["MyFilesTabDetails"];
        this.showSlider = this.tabDetails.length > 0 ? true : false;
        this.extraSpace = this.tabDetails.length > 0 ? false : true;
        this.universalService.hideTabs = false;
        this.universalService.showCreateFolderAndUploadButtons = true;
        if(!this.universalService.isUnivSharelink){
          this.universalService.headingTitle.set(this.currentView);
        }
        var tab = this.fetchCurrentTab();
        this.switchTab(tab)
        break;
      case "Favorites":
        this.currentView = "Favorites";
        this.tabDetails = this.tabData["FavoritesTabDetails"];
        this.universalService.showCreateFolderAndUploadButtons = false;
        this.showSlider = true;
        this.universalService.hideTabs = false;
        this.universalService.headingTitle.set(this.currentView);
        var tab = this.fetchCurrentTab();
        this.switchTab(tab)
        break;
      case "EmptyTab":
        this.tabDetails = this.tabData["EmptyTabDetails"];
        this.universalService.showCreateFolderAndUploadButtons = false;
        this.checkIfShowUploadAndCreateFolderButtonForEmptyTabbedView();
        this.showSlider = false;
        this.universalService.hideTabs = true;
        var modifiedTabName = this.fetchTabNameBasedonShowAndHideTabs(this.tabDetails,"EmptyTab");
        if(modifiedTabName != "EmptyTab") {
          this.renderTabbedView(modifiedTabName,true)
        }
        break; 
      case "Shared Files":
        this.currentView = "Shared Files";
        this.tabDetails = this.tabData["SharedFilesTabDetails"];
        this.universalService.headingTitle.set(this.currentView);
        this.showSlider = true;
        this.universalService.hideTabs = false;
        var tab = this.fetchCurrentTab();
        this.switchTab(tab)
        break;
      case "SharePublic":
        this.currentView = "Shared Files";
        this.tabDetails = this.tabData["SharedPublicFilesTabDetails"];
        this.universalService.headingTitle.set(this.currentView);
        var tab = this.tabDetails[0];
        this.switchTab(tab)
        break;
      case 'Albums':
        this.currentView = "Albums";
        this.tabDetails = this.tabData["AlbumsTabbedDetails"];
        this.universalService.headingTitle.set(this.currentView);
        var tab = this.fetchCurrentTab();
        this.switchTab(tab)
        break;
      case "Team_Folder_Admin":
        this.currentView = this.universalService.currentTeamFolder["tfName"];
        this.tabDetails = this.tabData["Team_Folder_Admin"];
        this.universalService.showCreateFolderAndUploadButtons = false;
        if(this.universalService.isMobileDevice){
          this.showSlider = false;
          this.universalService.hideTabs = true;
        }else{
          this.showSlider = true;
          this.universalService.hideTabs = false;
        }
        var tab = this.fetchCurrentTabTeamsFolder();
        this.switchTab(tab)
        break;
      case "Team_Folder_Member":
        this.currentView = this.universalService.currentTeamFolder["tfName"];
        this.tabDetails = this.tabData["Team_Folder_Member"];
        this.universalService.showCreateFolderAndUploadButtons = false;
        if(this.universalService.isMobileDevice){
          this.showSlider = false;
          this.universalService.hideTabs = true;
        }else{
          this.showSlider = true;
          this.universalService.hideTabs = false;
        }
        var tab = this.fetchCurrentTabTeamsFolder();
        this.switchTab(tab);
        break;
      case "Team_Folder_Member_Viewer":
      this.currentView = this.universalService.currentTeamFolder["tfName"];
      this.tabDetails = this.tabData["Team_Folder_Member_Viewer"];
      this.universalService.showCreateFolderAndUploadButtons = false;
      if(this.universalService.isMobileDevice){
        this.showSlider = false;
        this.universalService.hideTabs = true;
      }else{
        this.showSlider = true;
        this.universalService.hideTabs = false;
      }
      var tab = this.fetchCurrentTabTeamsFolder();
      this.switchTab(tab);
      break;
      default: 
        this.currentView = "My Files";
        this.tabDetails = this.tabData["MyFilesTabDetails"];
        this.universalService.headingTitle.set(this.currentView);
        var tab = this.fetchCurrentTabTeamsFolder();
        this.switchTab(tab)
        break;
    }
  }
  fetchCurrentTab(){ 
    var tab = this.router.url;
    tab = this.getCurrentTab(tab);
    switch(tab){
      case '/photos':
        return this.tabDetails[1]
      case '/audio':
        return this.tabDetails[3]
      case '/videos':
        return this.tabDetails[2]
      case '/docs':
        return this.tabDetails[4]
      case '/backups':
        return this.tabDetails[5]
      case '/favorites/myfiles':
        return this.tabDetails[0];
      case '/favorites/myalbums':
        return this.tabDetails[1];
      case '/shared/sharedbyme':
        return this.tabDetails[0];
      case '/shared/sharedwithme':
        return this.tabDetails[1];
      case '/shared/sharedlinkbyme':
        return this.tabDetails[2];
      case '/trash':
        return this.tabDetails[0];
      case '/shared':
        return this.tabDetails[0];
      case '/userprofile':
        return this.tabDetails[0];
      case '/contacts':
        return this.tabDetails[0];
      case '/albums/myalbums':
        return this.tabDetails[0];
      case '/albums/sharedalbums':
        return this.tabDetails[1];
      default:
        if(tab.includes('/?u=')){
          return this.tabDetails[0];
        }else{
          var data = this.setSliderToTheCurrentTab(tab);
          return data;
        }
    }
  }


  fetchCurrentTabTeamsFolder(){
    var tab = this.router.url;
    tab = this.getCurrentTab(tab);
    switch(tab){
    case '/folderinfo':
        return this.tabDetails[0];
    case '/members':
      return this.tabDetails[1];
    case '/trash':
      return this.tabDetails[2];
    case '/tflog':
      return this.tabDetails[3];
    case '/shareditems':
      return this.tabDetails[4];
    case '/settings':
      return this.tabDetails[5];
    default:
      var data = this.setSliderToTheCurrentTab(tab);
      return data;
    }
  }

  setSliderToTheCurrentTab(tab){
    if(tab.includes("sharedwithme")){
      this.setActiveTab(this.tabDetails[1])
    }else if(tab.includes("sharedbyme")){
      this.setActiveTab(this.tabDetails[0])
    }else if(tab.includes("sharedlinkbyme")){
      this.setActiveTab(this.tabDetails[2])
    }else if(tab.includes('allfiles')){
      this.setActiveTab(this.tabDetails[0]);
      // return this.tabDetails[0];
    }else if(tab.includes("recents")){
      //this.setActiveTab(this.tabDetails[0]);
      this.universalService.headingTitle.set("Recently Accessed");
    } else {
      this.setActiveTab(this.tabDetails[0]);
    }
  }
  getCurrentTab(tabname){
    if(tabname.includes('photos')){
      return '/photos'
    }else if (tabname.includes('audio')){
      return '/audio'
    }else if (tabname.includes('videos')){
      return '/videos'
    }else if (tabname.includes('docs')){
      return '/docs'
    }else if (tabname.includes('tfinfo')){
      return '/folderinfo'
    }else if (tabname.includes('members')){
      return '/members'
    }else if (tabname.includes('trash')){
      return '/trash'
    }else if (tabname.includes('tflog')){
      return '/tflog'
    }else if (tabname.includes('shareditems')){
      return '/shareditems'
    }else if (tabname.includes('settings')){
      return '/settings'
    }else{
      return tabname
    }
  }


  renderTabbedViewAsPerTab(tabName){
    this.bannerIsPresent = false;
    var bannerPresent = document.querySelector('#bannerContent')
    if(bannerPresent && bannerPresent.childElementCount > 0){
      this.bannerIsPresent = true;
    }else{
      this.bannerIsPresent = false;
    }
    this.renderTabbedView(tabName);
  }

  fetchJSONContents(){
    var self = this;
    self.universalService.removeEventListeners();
    return new Promise(function(resolve,reject){
      self.http.get(ENV_CONFIG.jsonUrls.tabbedView).subscribe(
        suc=>{
          self.tabData = suc["TabbedView"];
          self.registerEvents();
          self.applyTabViewClass();
          AppEvents.emit(EventsList.TABBED_VIEW_READY)
        }
      )
    })

  }

  fetchTabNameBasedonShowAndHideTabs(tabData, tabName){
    var arr = [{'tab':'allfiles','tabName':'My Files'}]
    var find = arr.find(obj=>obj['tab'] == this.universalService.currentTab)
    if(find && tabData.length == 0){
      return find['tabName'];
    }
    else return tabName;
  }
    
  setTabValuesForEmptyTabs(){
    var tab = "";
    var url = this.router.url;
    if(url.includes('trash')){
      tab = "Trash"
    }else if (url.includes('profile')){
      tab = "Profile"
    }else if (url.includes('orderhistory')){
      tab = "Order History"
    }else if (url.includes('contact')){
      tab = "Contacts"
    }else if (url.includes('buystorage')){
      tab = "Buy Storage"
    }else if (url.includes('favorites')){
      tab = "Favorites"
    }else if (url.includes('familyshare/addmember')){
      tab = "Add Member"
    }else if (url.includes('familyshare/memberlist')){
      tab = "Family Share"
    }else if (url.includes('/people')){
      tab = "People"
    }else if (url.includes('/places')){
      tab = "Places"
    }else if (this.universalService.activeRepo == 'share'){
      tab = "Shared Files"
    } else if (url.includes('/allfiles')){
      tab = "My Files"
    }else if (url.includes('history')){
      tab = "Export History"
    }else if (url.includes('dataexport')){
      tab = "Create Export"
    }else if (url.includes('teamfolders')){
      tab = "teamfolders"
    }else if (url.includes('privatefolder')){
      tab = "Private Folder"
    }else if ((url.includes('/albums/myalbums/') || url.includes('/albums/sharedalbums/'))){
      tab = "Album Details"
    }else if (url.includes('/albums/myalbums') || url.includes('/albums/sharedalbums')){
      tab = "Albums"
    }else if(url.includes('/search') ){
      tab = "Search Results"
    }else if(url.includes('/home') ){
      tab = "Home"
    }else if (url.includes('/recents')){
      tab = "Recently Accessed"
    }else if (url.includes('/ioscloudbridge')){
      tab = "CloudBridge"
    } else if (url.includes('/cloudbridge')){
      tab = "CloudBridge"
    } else if (url.includes('/digilocker')){
      tab = "DigiLocker"
    } else if (url.includes('/jpai')){
      tab = "JioPhoneCall AI"
    }
    this.currentView = tab;
    if(this.universalService.activeRepo == 'main') this.universalService.headingTitle.set(this.currentView);
    this.universalService.selectedTab = tab
  }

  showHideTabbedViewDropDown(event){
    // event.preventDefault();
    // event.stopPropagation();
    // (document.activeElement as any).blur();
    // if(this.showDropDown || event.target.classList.contains('drop-head')){
    //   this.showDropDown = false;
    // }else{
    //   this.showDropDown = !this.showDropDown;
    // }
  }
  checkIfShowUploadAndCreateFolderButtonForEmptyTabbedView(){
    var url = this.router.url;
    if(url.includes('home') ||url.includes('privatefolder') || (this.universalService.selectedTab == "Album Details" && this.universalService.isMobileDevice)){
      this.universalService.showCreateFolderAndUploadButtons = true;
    }
  }

  getDetailsOfCurrentTab(tabName){
    var found = this.tabDetails.find(item=>item["id"] == tabName);
    if(found){
      return found;
    }
    return false;
  }
}